import EditIcon from 'assets/icons/edit';
import { Button, Tooltip } from '@mui/material';

const EditButton = ({ handleOnClick }) => {
	return (
		<Tooltip title="Edit">
			<span>
				<Button
					size="small"
					variant="contained"
					onClick={handleOnClick}
					startIcon={<EditIcon width="14px" height="14px" color="#ffffff" />}
					sx={{
						minWidth: '80px',
						height: '36px',
						fontWeight: 400,
						fontSize: '13px',
						lineHeight: '20px',
						padding: '6px 14px',
						borderRadius: '10px',
						textTransform: 'none',
						boxShadow: 'none',
						backgroundColor: '#155DFC',
						transition: 'background-color 0.2s ease, transform 0.2s ease',
						color: '#ffffff',
						'& .MuiButton-startIcon': {
							marginRight: '6px',
							marginLeft: 0,
						},

						'&:hover': {
							backgroundColor: '#4096ff',
							boxShadow: 'none',
							transform: 'translateY(-1px)',
						},

						'&:active': {
							backgroundColor: '#0958d9',
							boxShadow: 'none',
							transform: 'translateY(0)',
						},

						'&.Mui-disabled': {
							backgroundColor: '#91caff',
							color: '#ffffff',
						},
					}}
				>
					Edit
				</Button>
			</span>
		</Tooltip>
	);
};

export default EditButton;
